/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Public API
 * API that powers FreightSimple\'s SPA
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Response from creating an account, includes conversion tracking flag
 * @export
 * @interface CreateAccountResponse
 */
export interface CreateAccountResponse {
    /**
     * Whether to fire the Google Ads Account Created conversion client-side
     * @type {boolean}
     * @memberof CreateAccountResponse
     */
    shouldFireSignupConversion: boolean;
}

/**
 * Check if a given object implements the CreateAccountResponse interface.
 */
export function instanceOfCreateAccountResponse(value: object): value is CreateAccountResponse {
    if (!('shouldFireSignupConversion' in value) || value['shouldFireSignupConversion'] === undefined) return false;
    return true;
}

export function CreateAccountResponseFromJSON(json: any): CreateAccountResponse {
    return CreateAccountResponseFromJSONTyped(json, false);
}

export function CreateAccountResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateAccountResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'shouldFireSignupConversion': json['shouldFireSignupConversion'],
    };
}

  export function CreateAccountResponseToJSON(json: any): CreateAccountResponse {
      return CreateAccountResponseToJSONTyped(json, false);
  }

  export function CreateAccountResponseToJSONTyped(value?: CreateAccountResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'shouldFireSignupConversion': value['shouldFireSignupConversion'],
    };
}

